export const Level = {
    IMPLEMENTATION: "implementation",
    DESIGN: "design"
}